import { render } from "./Kleinneuhausen.vue?vue&type=template&id=4b513997"
import script from "./Kleinneuhausen.vue?vue&type=script&lang=js"
export * from "./Kleinneuhausen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__